// 「LINEで続ける」ボタンと、LINE認可フロー開始ヘルパ。
// ブランドマークのみ FaLine(react-icons/fa6) を使用（UIアイコンは io5 に統一済み）。
import { FaLine } from "react-icons/fa6";

const CHANNEL_ID = process.env.REACT_APP_LINE_CHANNEL_ID || '';

// LINE連携の有効フラグ。CHANNEL_ID(REACT_APP_LINE_CHANNEL_ID)が設定されている時のみ有効。
// 未設定の間はログイン/新規登録のLINE導線を一切表示しない（準備中の機能を露出させない）。
// LINE準備完了後は env に REACT_APP_LINE_CHANNEL_ID を設定して再ビルドするだけで復活する。
export const lineEnabled = !!CHANNEL_ID;

// LINEに登録する callback。LINE Developers のチャネルに同一URLの登録が必要。
export function lineRedirectUri() {
  return window.location.origin + '/line/callback';
}

function randomStr(n) {
  const a = new Uint8Array(n);
  crypto.getRandomValues(a);
  return [...a].map((b) => b.toString(16).padStart(2, '0')).join('');
}

// LINE認可画面へ遷移（state/nonceをsessionStorageに保存しCSRF対策）
export function startLineAuth(flow = 'login') {
  if (!CHANNEL_ID) {
    alert('LINEログインは現在準備中です');
    return;
  }
  const state = randomStr(16);
  const nonce = randomStr(16);
  sessionStorage.setItem('line_state', state);
  sessionStorage.setItem('line_flow', flow);
  const url =
    'https://access.line.me/oauth2/v2.1/authorize?' +
    new URLSearchParams({
      response_type: 'code',
      client_id: CHANNEL_ID,
      redirect_uri: lineRedirectUri(),
      state,
      scope: 'profile openid email',
      nonce,
      // 同意画面に公式LINEの友だち追加オプションを表示（通知のLINE配信につながる）
      bot_prompt: 'normal',
    }).toString();
  window.location.href = url;
}

export function LineButton({ flow = 'login', label = 'LINEで続ける' }) {
  if (!lineEnabled) return null;
  return (
    <button type="button" className="line-button" onClick={() => startLineAuth(flow)} aria-label={label}>
      <FaLine className="line-button_icon" aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}

export default LineButton;
